/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'VERBAL_COMMUNICATION',
              'WRITTEN_COMMUNICATION_I_E_CURRENT_WORKERS_MIGHT_RECEIVE_WRITTEN',
              'POSTED_COMMUNICATION_I_E_DISPLAY_POSTINGS_AROUND_THE_FACILITY_',
              'MULTI_MEDIA_COMMUNICATION_I_E_WORKERS_WATCH_A_VIDEO_ONLINE_LEAR',
              'TRAINING_EXISTING_WORKERS_RECEIVE_ON_GOING_TRAININGS_IN_PERSON_',
              'COMMUNICATION_AND_TRAINING_IS_PROVIDED_IN_A_LANGUAGE_UNDERSTOOD',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    how_does_the_fac_prov_ongoing_comm_and_training_to_existing_pro: valueSchema,
  },
}
